var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardEmptyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08301 23.2093L23.1494 74.9111L98.227 53.0713L88.328 6L9.08301 23.2093Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.273 54.2986L21.9283 77.0888L6.91064 21.8902L89.6782 3.91602L100.273 54.2986ZM11.2555 24.5282L24.3705 72.7332L96.1806 51.8439L86.9781 8.08379L11.2555 24.5282Z",
    fill: "#9CA3AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.907 87.4597L61.9826 95.1659L61.5217 114L110.917 102.272L102.907 87.4597Z",
    fill: "#9CA3AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.542 103.448L59.7166 116.227L60.2676 93.7082L103.838 85.5037L113.542 103.448ZM63.6973 96.6238L63.3266 111.773L108.292 101.097L101.975 89.416L63.6973 96.6238Z",
    fill: "#9CA3AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9087 22.1613L25.3667 70.5757L98.227 53.0713L88.328 6L13.9087 22.1613Z",
    fill: "#DBEAFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.29 54.3756L24.0683 72.6875L11.7954 20.8295L89.6782 3.91602L100.29 54.3756ZM16.0224 23.493L26.6655 68.4638L96.1646 51.767L86.9781 8.08391L16.0224 23.493Z",
    fill: "#9CA3AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.328 6L13.9087 22.1613L16.8827 34.6566L90.7928 17.7353L88.328 6Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8587 19.0576L15.5819 36.7497L11.793 20.83L89.6785 3.91602L92.8587 19.0576ZM16.0244 23.4927L18.1833 32.5634L88.7268 16.413L86.9775 8.08402L16.0244 23.4927Z",
    fill: "#9CA3AF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9794 27.7667L77.5558 38.884L60.8429 35.8103L46.4985 59.4247L26.6658 49.3674L28.2487 46.2457L45.1902 54.837L59.1039 31.9317L76.0683 35.0516L83.1898 25.6528L85.9794 27.7667Z",
    fill: "#9CA3AF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5002 24.693L88.7425 29.447L85.5769 30.9401L84.1676 27.9521L79.1318 27.3841L79.5242 23.9062L86.5002 24.693Z",
    fill: "#9CA3AF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3103 27.8025L21.3982 29.0122L20.5613 25.6138L25.4733 24.4041L26.3103 27.8025Z",
    fill: "#9CA3AF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6831 93.9965L59.4573 78.516L70.2573 74.9109L64.7159 45.6883L74.5554 43.6182L78.5238 64.6542L101.182 61.411L102.907 87.4596L66.6831 93.9965Z",
    fill: "#9CA3AF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9329 62.6847L102.803 59.4112L104.756 88.9043L65.6673 95.9582L57.0413 77.4776L68.2529 73.7351L62.6768 44.329L75.9437 41.5378L79.9329 62.6847ZM66.7547 47.0476L72.2613 76.0869L61.8731 79.5545L67.6986 92.035L101.057 86.0152L99.5602 63.411L77.1144 66.6238L73.1668 45.6986L66.7547 47.0476Z",
    fill: "#9CA3AF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1922 93.9965L63.4028 79.2721L70.7895 77.7181L66.6005 45.2918L74.5553 43.6182L78.5237 64.6542L101.182 61.411L102.907 87.4596L68.1922 93.9965Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9329 62.6847L102.803 59.4112L104.755 88.8924L67.0039 96.0011L61.136 77.9609L68.8467 76.3385L64.6576 43.9123L75.9437 41.5378L79.9329 62.6847ZM68.5431 46.6714L72.7322 79.0977L65.6695 80.5835L69.3804 91.9921L101.058 86.0271L99.56 63.411L77.1143 66.6238L73.1668 45.6986L68.5431 46.6714Z",
    fill: "#9CA3AF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0749 70.5243L83.5932 70.8807L82.8435 63.5574L86.3254 63.2009L87.0749 70.5243Z",
    fill: "#9CA3AF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2613 69.2921L91.7745 69.5949L91.1797 62.7447L94.6665 62.4419L95.2613 69.2921Z",
    fill: "#9CA3AF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M102.907 87.4597L64.2386 94.7411L63.4028 110.595L110.917 102.272L102.907 87.4597Z",
    fill: "#DBEAFE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M113.612 103.577L61.5396 112.698L62.5634 93.2759L103.838 85.5037L113.612 103.577ZM65.9138 96.2065L65.2661 108.492L108.222 100.968L101.975 89.416L65.9138 96.2065Z",
    fill: "#9CA3AF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2313 100.326C98.9791 100.326 100.396 98.9091 100.396 97.1613C100.396 95.4135 98.9791 93.9966 97.2313 93.9966C95.4835 93.9966 94.0667 95.4135 94.0667 97.1613C94.0667 98.9091 95.4835 100.326 97.2313 100.326Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardEmptyIcon);
export default __webpack_public_path__ + "static/media/dashboardEmptyIcon.c0344cd92f567248171fcbe7bbf2d5b0.svg";
export { ForwardRef as ReactComponent };